// extracted by mini-css-extract-plugin
module.exports = {"container":"MiniNavbar_container__28gj-","navLink":"MiniNavbar_navLink__P3ajL","activeLink":"MiniNavbar_activeLink__28AhX"};